

























































import { Component, Mixins, Prop } from "vue-property-decorator";
import { Mixin } from "@/core/mixins/mixin";
import { NavBar, Row, Image, ImagePreview } from "vant";
import ItemTitle from "@/views/Mall/Payment/ItemTitle.vue";
import QRCode from "qrcodejs2";
@Component({
  components: {
    [NavBar.name]: NavBar,
    [Row.name]: Row,
    [Image.name]: Image,
    ItemTitle,
  },
})
export default class PerCode extends Mixins(Mixin) {
  @Prop({
    type: Boolean,
    default: true,
  })
  public isBorder!: boolean;
  @Prop({
    type: String,
    default: "",
  })
  public ticketCode!: string;
  @Prop({
    type: String,
    default: "",
  })
  public orderStatus!: string;

  @Prop({
    default: () => {
      return {};
    },
    type: Object,
  })
  public orderInfo!: any;

  mounted(): void {
    this.creatQrCode();
    console.log("orderStatus", this.orderStatus);
  }
  openImage(event: any): void {
    const dataURL = event.target.getAttribute("src"); // 转换为数据URL
    let imageUrl = dataURL;
    if (imageUrl) {
      ImagePreview({ images: [imageUrl], className: "showImagePreview" });
    } else if (event.target.toDataURL()) {
      ImagePreview({
        images: [event.target.toDataURL()],
        className: "showImagePreview",
      });
    }
  }
  /*
   *数字转二维码
   */
  creatQrCode(): void {
    new QRCode(this.$refs.qrCodeUrl, {
      text: `${this.ticketCode}`, // 需要转换为二维码的内容
      // width: 200,
      // height: 200,
      colorDark: "#000000",
      colorLight: "#ffffff",
      correctLevel: QRCode.CorrectLevel.H,
    });
  }
}
